import React, { useState, useEffect, useRef } from "react";

// =====================
// LOGIC (TOP)
// =====================
function PlanteraChatbot() {
  const [messages, setMessages] = useState([
    { sender: "bot", text: "I analyze environmental data and sustainability metrics 🌍" }
  ]);
  const [input, setInput] = useState("");
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userText = input;
    setInput("");

    setMessages(prev => [...prev, { sender: "user", text: userText }, { sender: "thinking" }]);

    try {
      const res = await fetch("https://comp-oriented.onrender.com/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userText })
      });

      const data = await res.json();

      setMessages(prev => {
        const filtered = prev.filter(m => m.sender !== "thinking");
        return [...filtered, { sender: "bot", text: data.reply || data.message || "No response" }];
      });
    } catch (e) {
      setMessages(prev => {
        const filtered = prev.filter(m => m.sender !== "thinking");
        return [...filtered, { sender: "bot", text: "Server error 😕" }];
      });
    }
  };

  return (
    <>
      <style>{`
        :root{
          font-size: clamp(14px, 1vw, 18px);
          --orange:#ff6b2c;
          --orange2:#ff925c;
          --border: rgba(255,255,255,0.45);
          --text:#1e1e1e;
        }
        *{ margin:0; padding:0; box-sizing:border-box; font-family: system-ui, -apple-system, Segoe UI, sans-serif; }
        body{
          min-height:100vh;
          background: radial-gradient(circle at top left, #fff4ec, #efe5db), radial-gradient(circle at bottom right, #ffe0cc, transparent);
          display:flex; align-items:center; justify-content:center;
          padding:2rem; overflow:hidden; perspective:1200px;
        }
        body::before{
          content:""; position:absolute; width:38rem; height:38rem;
          background:radial-gradient(circle, rgba(255,107,44,0.25), transparent 70%);
          filter:blur(6rem); animation: floatBg 12s ease-in-out infinite alternate;
        }
        @keyframes floatBg{ from{transform:translate(-4rem,-3rem)} to{transform:translate(4rem,3rem)} }
        .chatbot{
          width:100%; max-width:27rem; height:min(85vh,38rem);
          background:linear-gradient(180deg, rgba(255,255,255,0.35), rgba(255,255,255,0.15));
          backdrop-filter: blur(22px); border-radius:2rem; border:1px solid var(--border);
          box-shadow:0 30px 60px rgba(0,0,0,0.12);
          display:flex; flex-direction:column; padding:1.5rem;
          animation: cardFloat 8s ease-in-out infinite;
        }
        @keyframes cardFloat{ 0%,100%{transform:none} 50%{transform:rotateX(2deg) rotateY(-2deg)} }
        .header{
          font-size:1.35rem; font-weight:900; letter-spacing:0.14rem; text-align:center;
          background:linear-gradient(90deg, var(--orange), var(--orange2), var(--orange));
          -webkit-background-clip:text; -webkit-text-fill-color:transparent;
          margin-bottom:1.2rem;
        }
        .messages{ flex:1; overflow-y:auto; padding-right:0.4rem; }
        .msg{ max-width:78%; padding:0.75rem 1rem; border-radius:1.1rem; margin:0.55rem 0; font-size:0.9rem; line-height:1.55; }
        .user{ margin-left:auto; background:linear-gradient(135deg, var(--orange), var(--orange2)); color:white; }
        .bot{ background:rgba(255,255,255,0.75); color:var(--text); }
        .thinking span{ display:inline-block; width:0.35rem; height:0.35rem; margin-right:0.25rem; background:#777; border-radius:50%; animation:think 1.4s infinite both; }
        .thinking span:nth-child(2){animation-delay:.2s} .thinking span:nth-child(3){animation-delay:.4s}
        @keyframes think{0%{opacity:.3}20%{opacity:1}100%{opacity:.3}}
        .input-area{ display:flex; gap:0.7rem; margin-top:1rem; }
        input{ flex:1; padding:0.75rem 1rem; border-radius:1rem; border:none; background:rgba(255,255,255,0.85); }
        button{ padding:0.75rem 1.2rem; border-radius:1rem; border:none; font-weight:800; background:linear-gradient(135deg, var(--orange), var(--orange2)); color:white; cursor:pointer; }
      `}</style>

      <div className="chatbot">
        <div className="header">PLANTERA AI</div>

        <div className="messages">
          {messages.map((m, i) => (
            m.sender === "thinking" ? (
              <div key={i} className="msg bot">
                <div className="thinking"><span></span><span></span><span></span></div>
              </div>
            ) : (
              <div key={i} className={`msg ${m.sender}`}>{m.text}</div>
            )
          ))}
          <div ref={bottomRef} />
        </div>

        <div className="input-area">
          <input value={input} onChange={e => setInput(e.target.value)} placeholder="Ask something smart…" />
          <button onClick={sendMessage}>Send</button>
        </div>
      </div>
    </>
  );
}

export default PlanteraChatbot;
